<!--
  This icon is designed especially for Concertgebouw and not from an icon set,
  so be careful reusing it in other projects.
  -->

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol">
    <path
      fill="currentColor"
      d="M20.2.1c-.1-.1-.2-.1-.3-.1-.1 0-.2 0-.3.1l-7.3 4.2L9 6c-.1.1-.1.2-.2.3-.1 0-.1.2-.1.3v11.6c-.6-.4-1.3-.7-2-.7s-1.3.2-1.8.5c-.5.4-1 .9-1.2 1.4-.2.6-.3 1.2-.2 1.9.1.6.4 1.2.9 1.6.5.4 1 .8 1.7.9.6.3 1.3.2 1.9 0 .6-.2 1.1-.7 1.5-1.2.3-.6.5-1.2.5-1.8V10.2h.1l9.1-5v7.1c-.6-.4-1.3-.7-2-.7s-1.3.2-1.8.5c-.5.4-1 .9-1.2 1.4-.2.6-.3 1.2-.2 1.9.1.6.4 1.2.9 1.6.5.4 1 .8 1.7.9.6.1 1.3.1 1.9-.2.6-.2 1.1-.7 1.5-1.2.4-.5.6-1.2.6-1.8V.6c0-.1 0-.2-.1-.3-.1-.1-.2-.2-.3-.2z"
    />
  </svg>
</template>
